<script setup lang="ts">
import { ru } from '@nuxt/ui/locale'

import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

const is404 = computed(() => props.error?.status === 404)

const { routing } = useProducts()
const catalogRoute = computed(() => routing.getCatalog().route)

const handleError = () => clearError({ redirect: catalogRoute.value })

useSeoMeta({
  title: () => (is404.value ? 'Страница не найдена' : 'Ошибка'),
})
</script>

<template>
  <UApp :locale="ru" :toaster="{ position: 'top-right' }">
    <NuxtLayout>
      <div v-if="is404" class="flex flex-col items-center justify-center px-4 py-20 text-center">
        <img src="/404.svg" alt="" class="mb-8 w-full max-w-140">

        <h1 class="mb-4 text-2xl font-bold">
          Такой страницы нет
        </h1>

        <p class="mb-10 max-w-140 text-muted">
          Похоже, ссылка устарела или в адресе закралась ошибка.
        </p>

        <UButton
          :to="catalogRoute"
          size="xl"
          external
          @click="handleError"
        >
          В каталог
        </UButton>
      </div>

      <div v-else class="flex flex-col items-center justify-center px-4 py-20 text-center">
        <h1 class="mb-4 text-2xl font-bold">
          Произошла ошибка {{ error.status }}
        </h1>
        <p class="mb-10 max-w-140 text-muted">
          {{ error.message || 'Что-то пошло не так' }}
        </p>
        <UButton
          size="xl"
          @click="handleError"
        >
          В каталог
        </UButton>
      </div>
    </NuxtLayout>
  </UApp>
</template>
